import React from "react";
import { ArrowUpRightIcon, LinkedinIcon, MailIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../data/content";
export function Footer() {
  return <footer id="contact" className="bg-ink text-white" data-id="element-58" data-mp="32o48q3wk3w3d">
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:px-8 lg:pt-32" data-id="element-59" data-mp="32pp601a99t4x">
        <div className="flex flex-col justify-between gap-10 border-b border-white/15 pb-20 lg:flex-row lg:items-end" data-id="element-60" data-mp="36qhdoq3hbpz3">
          <h2 className="max-w-3xl font-display text-4xl font-semibold leading-[1.08] tracking-tight sm:text-6xl" data-id="element-61" data-mp="3ufjz8918i2yv">
            Une échéance réglementaire à préparer ? Parlons-en.
          </h2>
          <a href="mailto:contact@eleonorepara.fr" className="inline-flex w-fit items-center gap-3 whitespace-nowrap rounded-md bg-white px-7 py-4 text-base font-medium text-ink transition-colors duration-150 hover:bg-sand" data-id="element-62" data-mp="3ldu3ir0bkhva">
            Prendre rendez-vous
            <ArrowUpRightIcon className="h-5 w-5" data-id="element-63" data-mp="2ez1nkm2prl44" />
          </a>
        </div>

        <div className="grid gap-12 py-16 md:grid-cols-12" data-id="element-64" data-mp="3l8qxu8j60rtk">
          <div className="md:col-span-5" data-id="element-65" data-mp="3gagyrmubl72o">
            <Logo inverted data-id="element-66" data-mp="3gbiliokp7i08" />
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-white/60" data-id="element-67" data-mp="3gca5t38uhtb7">
              Conseil en affaires publiques et relations institutionnelles, spécialisé dans le secteur des jeux.
            </p>
          </div>
          <nav aria-label="Plan du site" className="md:col-span-3" data-id="element-68" data-mp="830k9lv0mb22">
            <h3 className="text-sm font-semibold text-white/50" data-id="element-69" data-mp="817cg38o1ksh">Navigation</h3>
            <ul className="mt-5 space-y-3" data-id="element-70" data-mp="335rtdvlddew">
              {navLinks.map(l => <li key={l.label} data-id="element-71" data-mp="ht3d9m24zp0e">
                  <a href={l.href} className="text-[15px] text-white/80 transition-colors duration-150 hover:text-white" data-id="element-72" data-mp="hs1x5369kcbt">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <div className="md:col-span-4" data-id="element-73" data-mp="ms6h536drp6s">
            <h3 className="text-sm font-semibold text-white/50" data-id="element-74" data-mp="mthkj1vwyuxd">Contact</h3>
            <ul className="mt-5 space-y-3" data-id="element-75" data-mp="tvw9ald1dni3">
              <li data-id="element-76" data-mp="tt09erhmoor0">
                <a href="mailto:contact@eleonorepara.fr" className="inline-flex items-center gap-3 text-[15px] text-white/80 hover:text-white" data-id="element-77" data-mp="yu7h6qjrtnxo">
                  <MailIcon className="h-4 w-4" data-id="element-78" data-mp="13sipgwuf3qds" /> contact@eleonorepara.fr
                </a>
              </li>
              <li data-id="element-79" data-mp="18lk8nh1nqc36">
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 text-[15px] text-white/80 hover:text-white" data-id="element-80" data-mp="18m3sx4es5ckd">
                  <LinkedinIcon className="h-4 w-4" data-id="element-81" data-mp="1hj4buvj2yigf" /> LinkedIn
                </a>
              </li>
              <li className="text-[15px] text-white/60" data-id="element-82" data-mp="1mkbiusdefdm1">Paris, France</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-white/15 py-8 text-sm text-white/50 sm:flex-row sm:justify-between" data-id="element-83" data-mp="1rgsgcd6hn4bs">
          <p data-id="element-84" data-mp="3t9ylnzsh707e">© 2026 Éléonore Para. Tous droits réservés.</p>
          <p data-id="element-85" data-mp="3tahyx376l0f3">Activité référencée au répertoire de la HATVP</p>
        </div>
      </div>
    </footer>;
}